import { render, staticRenderFns } from "./ConsultCard.vue?vue&type=template&id=6c358490"
import script from "./ConsultCard.vue?vue&type=script&lang=ts"
export * from "./ConsultCard.vue?vue&type=script&lang=ts"
import style0 from "./ConsultCard.vue?vue&type=style&index=0&id=6c358490&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports